import {elementInScopeVertically, scrollToElementHorizontallyIfNeed} from "./common/ui";

(function () {
	function initCurrentStateUI() {
		function toggleNavButtonActiveState(targetId) {
			navLinks.forEach((navLink) => {
				const anchorId = navLink.getAttribute('data-anchor-id');
				if (targetId === anchorId) {
					scrollToElementHorizontallyIfNeed(navLink.closest('li'), navLink.closest('ul'));

					const targetNavBlock = navLink.closest('.sys__nav-block');
					if (!!targetNavBlock) {
						navBlocks.forEach(navBlock => {
							navBlock.classList.toggle('nav-block--collapsed', targetNavBlock !== navBlock);
						})
					}
				}
				navLink.classList.toggle('nav-block__link--current', targetId === anchorId);
			})
		}

		function initNavCurrentState() {
			[...blocks].every(block => {
				if (elementInScopeVertically(block)) {
					toggleNavButtonActiveState(block.id);
					return false;
				}
				return true;
			})
		}

		const blocks = document.querySelectorAll('.sys__nav-block-content');
		const navBlocks = document.querySelectorAll('.sys__nav-block');
		const navLinks = document.querySelectorAll('.sys__nav-block-link');
		document.addEventListener('scroll', function () {
			initNavCurrentState();
		})

		initNavCurrentState();
	}

	document.addEventListener('DOMContentLoaded', function () {
		initCurrentStateUI();
	});
})();
